<template lang="pug">
.scene-container
  main.page.index
    .row
      h1.page-title Protium brand assets
      navigation.sub
</template>

<script>
// import Vue from 'vue'
// import pageBase from '@/scenes/_pageBase.js'
import Navigation from '@/components/Navigation'

export default {
  name: 'defaultscene',
  // mixins: [pageBase],
  data: function () {
    return {
    }
  },
  components: {Navigation},
  methods: {
  },
  mounted () {
  }
}

</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/scenes/defaultscene.vue